var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.142578,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#52D5BA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_3035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82069 9.89227L5.21653 8.2881C5.03778 8.10935 4.75361 8.10935 4.57486 8.2881C4.39611 8.46685 4.39611 8.75102 4.57486 8.92977L6.49528 10.8502C6.67403 11.0289 6.96277 11.0289 7.14153 10.8502L11.9999 5.99643C12.1786 5.81768 12.1786 5.53352 11.9999 5.35477C11.8211 5.17602 11.5369 5.17602 11.3582 5.35477L6.82069 9.89227Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_3035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(2.69568 2.4668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.c3122afb531294d2ef55f14e5f6c13af.svg";
export { ForwardRef as ReactComponent };